import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Button, Grid } from "@material-ui/core";
import Rating from "@material-ui/lab/Rating";
import { makeStyles } from "@material-ui/core/styles";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { Base64 } from "js-base64";

import { apiUrl, updateHeight } from "../common";
import PoweredBy from "../powered-by";
import "./index.css";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";

const useStyles = makeStyles((theme) => ({
  root: {},
  body: {
    margin: "0 auto",
  },
  head: {
    position: "relative",
    backgroundColor: "#3f51b5",
  },
  title: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#fff",
    lineHeight: "40px",
  },
  colorWhite: {
    color: "#fff!important",
  },
  badge: {
    color: "#fff",
    width: 32,
    height: 32,
    lineHeight: "32px",
    borderRadius: "50%",
    textAlign: "center",
    fontSize: 12,
    position: "absolute",
  },
  box: {
    height: "100%",
    maxWidth: 200,
    margin: "0 auto",
    fontSize: 13,
    fontWeight: "bold",
    boxSizing: "border-box",
  },
  wrapImg: {
    flex: "1 0 auto",
  },
  wrapContent: {
    // flexShrink: "0",
  },
  permalink: {
    color: "initial",
    textDecoration: "none",
    display: "flex",
  },
  img: {
    maxWidth: "100%",
    maxHeight: 200,
    margin: "8px auto",
  },
  name: {},
  regularPrice: {
    fontSize: 10,
    color: "#716b6b",
    textDecoration: "line-through",
  },
  price: {
    fontSize: 12,
  },
  review: {
    fontSize: 12,
    fontWeight: "normal",
    color: "#716b6b",
    marginLeft: "8px",
  },
}));

const Recommender = () => {
  const classes = useStyles();
  const { p } = useParams();
  const param = JSON.parse(decodeURIComponent(p));
  const [data, setData] = useState();
  const messageType = "product-recommend";
  //const [active, setActive] = useState(0);
  //console.log(p);
  useEffect(() => {
    //if (!data) {
    //window.addEventListener("message", (event) => {
    //console.log(event.data);
    //if (event.origin === window.origin) return;

    //let data = event.data;
    //console.log(data.value);
    //if (data.key === "init") {
    //}
    //});
    //}
    if (p && !data) {
      getData(param);
    }
    //console.log("load recommended");
  }, []);

  const getData = (param) => {
    var url = `${
      window.location.hostname.includes("local")
        ? //? "https://localhost:5001"
          "https://localhost:44337"
        : "https://recommender.ezca.asia"
    }/api/prediction/${param.webId}`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({
        ...param,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        if (!res.success) return;
        if (!res.data.recommender) {
          res.data.recommender = {
            cta: "MUA NGAY",
            ctaColor: "#1DA1F2",
            nameColor: "#14171A",
            priceColor: "#d70018",
            saleColor: "#1DA1F2",
            title: "CÓ THỂ BẠN SẼ THÍCH",
            titleColor: "#1DA1F2",
          };
        } else if (
          res.data.recommender.customCss &&
          !document.getElementById("customCss")
        ) {
          let css = res.data.recommender.customCss;
          var style = document.createElement("style");
          style.id = "customCss";
          style.innerHTML = css;
          document.head.appendChild(style);
        }
        setData(res);
        updateHeight("recommender");

        //not preview
        if (param.id && false) {
          fetch(`${apiUrl}/api/public/UpdateCount/${param.id}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              type: messageType,
              countView: true,
            }),
          });
        }
      });
  };

  const createUTMLink = (item) => {
    let param = {
      source: messageType,
    };
    return `${decodeURIComponent(item.permalink)}?ezca_pr=${Base64.encodeURI(
      JSON.stringify(param)
    )}&utm_content=ezca-recommend`;
  };

  return (
    <Box className={classes.root}>
      {data && (
        <Box>
          <Box
            display="flex"
            className={`box-head ${classes.head}`}
            style={{ backgroundColor: data.data.recommender.titleColor }}
          >
            <Box className="box-head__pulse blob white"></Box>
            <Box className={`box-head__title ${classes.title}`}>
              {data.data.recommender.title}
            </Box>
          </Box>
          <Splide
            options={{
              type: "loop",
              autoplay: false,
              perPage:
                window.innerWidth < 500
                  ? 2
                  : !data.data.recommender.perPage ||
                    data.data.recommender.perPage == 0
                  ? 5
                  : data.data.recommender.perPage,
              perMove: 1,
              gap: ".5rem",
              pagination: false,
            }}
          >
            {data.data.items.map((item, index) => (
              <SplideSlide key={index}>
                <Box
                  className={`product-item ${classes.box}`}
                  display="flex"
                  flexDirection="column"
                  // onMouseEnter={() => setActive(item.id)}
                  // onMouseLeave={() => setActive(0)}
                >
                  {item.regularPrice > item.price && (
                    <div
                      className={`product-item__badge ${classes.badge}`}
                      style={{
                        backgroundColor: data.data.recommender.saleColor,
                      }}
                    >
                      {`-${(
                        100 -
                        (item.price / item.regularPrice) * 100
                      ).toFixed(0)}%`}
                    </div>
                  )}
                  <Box className={classes.wrapImg}>
                    <a
                      className={`${classes.permalink}`}
                      href={createUTMLink(item)}
                      target="_parent"
                    >
                      <img
                        className={`product-item__img ${classes.img}`}
                        src={item.imageUrl}
                      />
                    </a>
                  </Box>
                  <Box className={classes.wrapContent}>
                    <a
                      className={classes.permalink}
                      href={createUTMLink(item)}
                      target="_parent"
                    >
                      <div
                        className={`product-item__name text-three-line ${classes.name}`}
                        style={{ color: data.data.recommender.nameColor }}
                        title={item.name}
                      >
                        {item.name}
                      </div>
                    </a>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <span
                        className={`product-item__price ${classes.price}`}
                        style={{ color: data.data.recommender.priceColor }}
                      >
                        {item.price.toLocaleString() + "₫"}
                      </span>
                      {item.regularPrice > item.price && (
                        <span
                          className={`product-item__regular-price ${classes.regularPrice}`}
                        >
                          {item.regularPrice.toLocaleString() + "₫"}
                        </span>
                      )}
                    </Box>
                    {item.ratingCount > 0 && (
                      <Box display="flex">
                        <Rating
                          readOnly
                          size="small"
                          precision={0.1}
                          value={parseFloat(item.averageRating ?? "0")}
                        />
                        <span className={classes.review}>
                          ({item.ratingCount} đánh giá)
                        </span>
                      </Box>
                    )}
                    {true && (
                      <Box mt={1}>
                        <Button
                          fullWidth
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            window.open(createUTMLink(item), "_parent");
                          }}
                          style={{
                            color: data.data.recommender.ctaColor,
                            borderColor: data.data.recommender.ctaColor,
                          }}
                          className={`product-item__button`}
                        >
                          {data.data.recommender.cta ?? "Mua ngay"}
                        </Button>
                      </Box>
                    )}
                  </Box>
                </Box>
              </SplideSlide>
            ))}
          </Splide>
        </Box>
      )}
      <PoweredBy
        planId={param.planId}
        widget={"recommender"}
        color="#fff"
        dh={param.dh}
      />
    </Box>
  );
};

export default Recommender;
